<template>
    <div>
        <v-server-table ref="correctiveActionsTable" url="/corrective-actions/list" :columns="columns" :options="options">

            <template slot="corrective_action_id" slot-scope="props">
                <span v-if="assetType == 'Dashboard'" style="white-space: nowrap;">
                    <router-link :to="`/corrective-actions/view/${props.row.corrective_action_id}`" class="btn btn-sm btn-light mr-1 mb-xl-0 mb-lg-2 mb-0 d-xl-inline d-lg-block d-inline">
                        <i class="fa fa-eye"></i> View
                    </router-link>
                    <!-- <router-link :to="`/corrective-actions/edit/${data.item.corrective_action_id}`">Edit</router-link>&nbsp;|&nbsp; -->
                    <router-link :to="`/corrective-actions/complete/${props.row.corrective_action_id}`" class="btn btn-sm btn-light">
                        <i class="fa fa-flag-checkered"></i> Complete
                    </router-link>
                </span>
                <router-link v-else slot="corrective_action_id" slot-scope="props" :to="`/corrective-actions/view/${props.row.corrective_action_id}`" title="View Corrective Action" class="btn btn-sm btn-light">
                    View CA-{{ props.row.corrective_action_id }}
                </router-link>
            </template>

            <router-link slot="asset_type" slot-scope="props" :to="`/${assetTypeUrl(props.row.asset_type)}/${props.row.asset_id}`" :title="`View ${props.row.asset_type}`">
                {{ props.row.asset_type }} {{ props.row.asset_id }}
            </router-link>

            <template slot="JobsiteName" slot-scope="props">
                <div v-if="props.row.JobsiteId">
                    <router-link :to="`/jobsites/view/${props.row.JobsiteId}`" :title="`View Jobsite`" v-if="canViewJobsites">
                        {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                    </router-link>
                    <span v-else>
                        {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                    </span>
                </div>
                <div v-else>
                    {{ props.row.JobsiteName }}
                </div>
            </template>

            <template slot="DivisionName" slot-scope="props">
                <span v-if="props.row.division_code">{{ props.row.division_code }} - </span>{{ props.row.DivisionName }}
            </template>

            <template slot="status_name" slot-scope="props">
                <label :class="`badge badge-${props.row.status_color}`">
                    {{ props.row.status_name }}
                </label>
            </template>

            <template slot="assignee_first_name" slot-scope="props">
                <label class="badge badge-warning small" v-if="props.row.subcontractor_id" title="Subcontractor User">SUB</label>
                <user-name :user="assignee(props.row)" />
                <template v-if="props.row.subcontractor_id">
                    - {{ props.row.subcontractor_name }}
                </template>
            </template>

            <template slot="creator_first_name" slot-scope="props">
                <user-name :user="creator(props.row)" />
            </template>

            <template slot="completer_first_name" slot-scope="props">
                <user-name :user="completer(props.row)" />
            </template>

            <template slot="other_assignees" slot-scope="props">
                <template v-if="props.row.other_assignees">
                    <span v-for="(assign, i) in props.row.other_assignees">
                        <template v-if="i > 0">, </template>{{ assign.FirstName }} {{ assign.LastName }}
                    </span>
                </template>
            </template>

            <template slot="completed_at" slot-scope="props">
                <template v-if="props.row.completed_at">{{ props.row.completed_at | moment("MM/DD/YYYY hh:mm a") }}</template>
            </template>

            <template slot="created_at" slot-scope="props">
                <template v-if="props.row.created_at">{{ props.row.created_at | moment("MM/DD/YYYY hh:mm a") }}</template>
            </template>

            <template slot="due_date" slot-scope="props">
                <label v-if="props.row.due_date && props.row.status_context != 'Closed' && isOverdueVar(props.row.due_date)" class="badge badge-danger" title="Action is Overdue">
                    {{ props.row.due_date | moment("MM/DD/YYYY") }}
                </label>
                <template v-else-if="props.row.due_date">
                    {{ props.row.due_date | moment("MM/DD/YYYY") }}
                </template>
            </template>

            <template slot="child_row" slot-scope="props">
                <span class="font-weight-bold">Details:</span><br>
                <div v-html="props.row.detail"></div>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: ['assetType', 'timeFilter'],

        data: function() {
            return {
                exportingTable: false,
                today: moment().format('YYYY-MM-DD'),
                isOverdueVar: this.isOverdue,
                options: {
                    headings: {
                        corrective_action_id: 'View',
                        asset_type: 'Attached To',
                        JobsiteName: 'Jobsite',
                        DivisionName: 'Division',
                        status_name: 'Status',
                        assignee_first_name: this.assetType != 'Dashboard' ? 'Assignee' : 'Assigned To',
                        completer_first_name: 'Completer',
                        due_date: 'Due',
                        completed_at: 'Completed',
                        creator_first_name: this.assetType != 'Dashboard' ? 'Creator' : 'Created By',
                        other_assignees: 'Other Assignees',
                        created_at: 'Created',
                        hours_to_completion: 'Hours to Completion',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'corrective_actions.created_at',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('correctiveActionCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        data.assetType = this.assetType;

                        if (this.assetType == 'Dashboard')
                        {
                            return data;
                        }

                        //Set the filters
                        data.filters = {
                            'corrective_actions.created_at': this.timeFilter.toLowerCase(),
                        };

                        this.getPreviousData();

                        //Send it
                        return data;
                    },
                    uniqueKey: 'corrective_action_id',
                    showChildRowToggler: this.assetType != 'Dashboard',
                },
            }
        },

        computed: {
            canViewAllCorrectiveActions(){
                return this.$root.hasPermission('correctiveActions.view.browse');
            },

            canViewJobsites(){
                return this.$root.hasPermission('jobsites.view');
            },

            columns() {
                if (this.assetType == 'Dashboard')
                {
                    return [
                        'corrective_action_id',
                        'asset_type',
                        'status_name',
                        'creator_first_name',
                        'assignee_first_name',
                        'other_assignees',
                        'due_date',
                    ];
                }
                return [
                    'corrective_action_id',
                    'asset_type',
                    'JobsiteName',
                    'DivisionName',
                    'status_name',
                    'creator_first_name',
                    'assignee_first_name',
                    'completer_first_name',
                    'other_assignees',
                    'created_at',
                    'due_date',
                    'completed_at',
                    'hours_to_completion'
                ];
            }
        },

        methods: {
            assignee(row) {
                return {
                    FirstName: row.assignee_first_name,
                    LastName: row.assignee_last_name,
                    deleted_at: row.assignee_deleted_at,
                };
            },

            creator(row) {
                return {
                    FirstName: row.creator_first_name,
                    LastName: row.creator_last_name,
                    deleted_at: row.creator_deleted_at,
                };
            },

            completer(row) {
                return {
                    FirstName: row.completer_first_name,
                    LastName: row.completer_last_name,
                    deleted_at: row.completer_deleted_at,
                };
            },

            assetTypeUrl: function(asset_type) {
                if (asset_type == 'InspectionResult')
                    return 'inspections/result';
                return asset_type+'s/view'
            },

            isOverdue(date){
                //Testing
                //console.log(date);
                //return true;

                //Check if date is GREATER than today
                var d = moment(date);

                //Send it
               return d.isBefore(this.today);
            },

            getPreviousData: function() {
                this.$http.get('/corrective-actions/list', {'filters': {'corrective_actions.created_at': 'prev_'+this.timeFilter.toLowerCase()}})
                .then(response => {
                    this.$emit('prevCorrectiveActionCount', response.data.count);
                })
                .catch(err => {

                })
                .then(() => {

                });
            },
        },
    }
</script>
